export default {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
}
